import { Search } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function SearchTrackerPage() {
  return (
    <>
      <PageHeader
        icon={Search}
        title="Search Tracker"
        description="Snapshot a search query on a schedule and diff results over time."
      />
      <ComingSoon what="Search Tracker UI" />
    </>
  );
}
